export function getDayProgramTel(
  organizationName?: string,
  organizationTel?: string,
  linkUrl?: string,
): string | undefined {
  // If organization is set, always use that telephone number.
  if (organizationName) {
    return organizationTel;
  }

  // Otherwise use the link if it is a telephone number.
  if (linkUrl && /^tel:/.test(linkUrl)) {
    // Slice off 'tel:'
    return linkUrl.slice(4);
  }

  return undefined;
}

export function getDayProgramEmail(
  organizationName?: string,
  organizationEmail?: string,
  linkUrl?: string,
): string | undefined {
  // If organization is set, always use that email address.
  if (organizationName) {
    return organizationEmail;
  }

  // Otherwise use the link if it is an email address.
  if (linkUrl && /^mailto:/.test(linkUrl)) {
    // Slice off 'mailto:'
    return linkUrl.slice(7);
  }

  return undefined;
}
